import { useState } from "react";
import { Search } from "lucide-react";
import { ICON_LIST, CategoryIcon } from "@/lib/iconLibrary";

const IconPicker = ({ value, onChange, label }) => {
  const [q, setQ] = useState("");
  const term = q.trim().toLowerCase();
  const filtered = term
    ? ICON_LIST.filter((i) => i.name.includes(term) || i.keywords.includes(term))
    : ICON_LIST;

  return (
    <div>
      {label && <label className="text-sm font-medium text-foreground mb-1 block">{label}</label>}
      <div className="relative mb-2">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Pesquisar ícone..."
          data-testid="icon-search"
          className="w-full pl-8 pr-3 py-2 rounded-lg border border-border bg-background outline-none focus:border-primary text-sm"
        />
      </div>
      <div className="grid grid-cols-6 sm:grid-cols-8 gap-2 max-h-40 overflow-y-auto p-1 border border-border rounded-xl">
        {filtered.map(({ name }) => (
          <button
            key={name}
            type="button"
            onClick={() => onChange(name)}
            data-testid={`icon-option-${name}`}
            title={name}
            className={`aspect-square rounded-lg flex items-center justify-center border transition-colors ${value === name ? "bg-primary text-primary-foreground border-primary" : "border-border hover:border-primary text-foreground"}`}
          >
            <CategoryIcon name={name} className="w-5 h-5" />
          </button>
        ))}
      </div>
      {value && (
        <p className="text-xs text-muted-foreground mt-1">
          Selecionado: <b>{value}</b>{" "}
          <button type="button" onClick={() => onChange("")} className="text-destructive ml-1">retirar</button>
        </p>
      )}
    </div>
  );
};

export default IconPicker;
